/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ApiKeyStatus = 'ACTIVE' | 'INACTIVE' | 'EXPIRED';

export const ApiKeyStatus = {
    Active: 'ACTIVE' as ApiKeyStatus,
    Inactive: 'INACTIVE' as ApiKeyStatus,
    Expired: 'EXPIRED' as ApiKeyStatus
};

